/* eslint-disable */
import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
// import { LIST_CHANNEL } from '../../../../../../constants/index'
// import './style.css';

import searchIcon from '../../../../_assets/images/search-icon.png';

function DropdownTable({isListStatus, setSavedFilter, SavedFilter}) {
    const [isChannelActive, setChannelActive] = useState(true)
    const [isLabelActive, setLabelActive] = useState(false)
    const [isListFilter, setListFilter] = useState({})
    const [isListKey, setListKey] = useState([])
    const [checked, setChecked] = useState([]);
    const [isSearch, setSearch] = useState('');

    useEffect( () => {
        let data = {
            application: [],
            status: isListStatus,
        }
        setListKey(["Application Name", "Status"])
        setListFilter(data)
        setChecked(SavedFilter)
    }, []);

    function handleSearchFilter(e) {
        let key = e.target.value
        let data = {
            application: [],
            status: isListStatus,
        }
        data.application = data.application.filter(d => d.name.includes(key));
        data.status = data.status.filter(d => d.name.includes(key));

        setListFilter(data)
        setChannelActive(true)
        setLabelActive(true)
        // setAgentActive(true)
        setSearch(key);
    }

    const handleCheck = (event, type) => {
        let updatedList = [...checked];
        if (event.target.checked) {
          updatedList = [...checked, {type: type, value: event.target.value}];
        } else {
          updatedList.splice(checked.findIndex(d => d.value === event.target.value), 1);
        }
        // console.log(updatedList, checked.findIndex(d => d.value === event.target.value)); 
        setChecked(updatedList);
    };

    const defaultCheckboxValue = (name) => {
        // let val = {type: type, value: name}
        return checked.some(d => d.value === name)
    };

    const saveFilter = () => {
        console.log('checked',checked)
        setSavedFilter(checked)
    };

    // isListFilter.map((item)=>{
    //     console.log('itemss',item)
    // })

  return (
    <div className="flex container-dropdown">
        <div className="flex flex-1 flex-col list-dropdown">
            <div className="d-flex flex-1 justify-content-between head-dropdown">
                <span className="title">Filters</span>
                <span onClick={() => saveFilter()} className="save">Apply</span>
            </div>
            <div className="d-flex flex-row search-item ">
                <img src={searchIcon} alt="" />   
                <input type="text" value={isSearch} onChange={handleSearchFilter}
                  className="appearance-none text-xs lg:text-xss md:text-xss bg-transparent border-none w-100 text-gray-700 leading-tight focus:outline-none"  
                  placeholder="Search"  /> 
            </div>
            <div className="flex flex-col main-dropdown overflow-y-auto">
                {isListKey.map((val, index) =>
                    <div key={index} className="flex flex-col">
                        <div onClick={() => {
                            val === "Application Name" && setChannelActive(!isChannelActive);
                            val === "Status" && setLabelActive(!isLabelActive);
                            }} className="flex flex-row sub-list-filter">
                            {val === "Application Name" && 
                                <svg className={" " + (isChannelActive ? "rotates-0" : "rotates--90")} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.75 6.8775C12.6095 6.73781 12.4194 6.65941 12.2213 6.65941C12.0231 6.65941 11.833 6.73781 11.6925 6.8775L9.00002 9.5325L6.34502 6.8775C6.2045 6.73781 6.01441 6.65941 5.81627 6.65941C5.61813 6.65941 5.42804 6.73781 5.28752 6.8775C5.21723 6.94723 5.16143 7.03018 5.12335 7.12157C5.08528 7.21296 5.06567 7.31099 5.06567 7.41C5.06567 7.50901 5.08528 7.60704 5.12335 7.69844C5.16143 7.78983 5.21723 7.87278 5.28752 7.9425L8.46752 11.1225C8.53724 11.1928 8.6202 11.2486 8.71159 11.2867C8.80298 11.3247 8.90101 11.3444 9.00002 11.3444C9.09903 11.3444 9.19706 11.3247 9.28846 11.2867C9.37985 11.2486 9.4628 11.1928 9.53252 11.1225L12.75 7.9425C12.8203 7.87278 12.8761 7.78983 12.9142 7.69844C12.9523 7.60704 12.9719 7.50901 12.9719 7.41C12.9719 7.31099 12.9523 7.21296 12.9142 7.12157C12.8761 7.03018 12.8203 6.94723 12.75 6.8775Z" fill="#97A0AF"/>
                                </svg>
                            }
                            {val === "Status" && 
                                <svg className={" " + (isLabelActive ? "rotates-0" : "rotates--90")} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.75 6.8775C12.6095 6.73781 12.4194 6.65941 12.2213 6.65941C12.0231 6.65941 11.833 6.73781 11.6925 6.8775L9.00002 9.5325L6.34502 6.8775C6.2045 6.73781 6.01441 6.65941 5.81627 6.65941C5.61813 6.65941 5.42804 6.73781 5.28752 6.8775C5.21723 6.94723 5.16143 7.03018 5.12335 7.12157C5.08528 7.21296 5.06567 7.31099 5.06567 7.41C5.06567 7.50901 5.08528 7.60704 5.12335 7.69844C5.16143 7.78983 5.21723 7.87278 5.28752 7.9425L8.46752 11.1225C8.53724 11.1928 8.6202 11.2486 8.71159 11.2867C8.80298 11.3247 8.90101 11.3444 9.00002 11.3444C9.09903 11.3444 9.19706 11.3247 9.28846 11.2867C9.37985 11.2486 9.4628 11.1928 9.53252 11.1225L12.75 7.9425C12.8203 7.87278 12.8761 7.78983 12.9142 7.69844C12.9523 7.60704 12.9719 7.50901 12.9719 7.41C12.9719 7.31099 12.9523 7.21296 12.9142 7.12157C12.8761 7.03018 12.8203 6.94723 12.75 6.8775Z" fill="#97A0AF"/>
                                </svg>
                            }
                            <span>{val}</span>
                        </div>
                        {(val === "Application Name" && isChannelActive) &&
                            <div className="flex flex-col my-1">
                                {isListFilter.application.map((item, index) =>
                                    <div key={index} className="item-dropdown-filter check-radio-custom">
                                        <input className="checkbox-custom checkbox-effect checkbox-effect-1" type="checkbox" 
                                         onChange={(e) => handleCheck(e, 'application')} value={item.name} 
                                         defaultChecked={defaultCheckboxValue(item.name)} name={item.name}/>
                                        <label>{item.name}</label>
                                    </div>
                                )}
                            </div>
                        }
                        {(val === "Status" && isLabelActive) &&
                            <div className="flex flex-col my-1">
                                {isListFilter.status.map((item, index) =>
                                    <div key={index} className="item-dropdown-filter check-radio-custom">
                                        <input className="checkbox-custom checkbox-effect checkbox-effect-1" type="checkbox" 
                                         onChange={(e) => handleCheck(e, 'status')} value={item.value} 
                                         defaultChecked={defaultCheckboxValue(item.value)} name={item.value}/>
                                        <label>{item.name}</label>
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                )}

            </div>
        </div>
    </div>
  )
}

DropdownTable.propTypes = {
    ListAgent: PropTypes.array,
    isListStatus: PropTypes.array,
    SavedFilter: PropTypes.array,
    setSavedFilter: PropTypes.func
};

export default DropdownTable;